<template>
  <div :class="$style.container">
    <div
      :class="[
        $style.card,
        { FlipCard__flipped: flipped === true },
        {
          FlipCard__white: config.colour !== 'blue',
        },
        { FlipCard__blue: config.colour === 'blue' },
      ]"
      @mouseenter="flipped = true"
      @mouseleave="flipped = false"
      @touchstart="flipped = !flipped"
    >
      <div :class="$style.content">
        <template v-if="isDesktopOrWidescreen">
          <div :class="$style.front">
            <img
              v-if="config.image"
              :alt="config.title"
              :class="$style.image"
              :src="config.image"
            />

            <BigIcon
              v-if="config.icon"
              :class="$style.icon"
              :icon="config.icon"
              :is-icon-white="config.colour === 'blue'"
            />

            <h4 :class="$style.title">{{ config.title }}</h4>
          </div>
          <div :class="$style.back">
            <p :class="$style.title">{{ config.title }}</p>
            <div v-if="config.text" :class="$style.text" v-html="config.text" />
          </div>
        </template>
        <template v-else>
          <div :class="$style.back">
            <BigIcon
              v-if="config.icon"
              :class="$style.icon"
              :icon="config.icon"
              :is-icon-white="config.colour === 'blue'"
            />

            <p :class="$style.title">{{ config.title }}</p>
            <div v-if="config.text" :class="$style.text" v-html="config.text" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { isDesktopOrWidescreen } from '../../utils/breakpoints';
import BigIcon from '../Icon/components/BigIcon/BigIcon.vue';

defineProps({
  config: {
    type: Object,
    default: () => {},
  },
});

const flipped = ref(false);
</script>

<style module lang="scss">
@forward './FlipCard.scss';
</style>
